import React, { useEffect, useState } from "react";
import { useIsFocused, useNavigation, useRoute } from "@react-navigation/native";
import i18n from "utils/i18n";
import _ from "lodash";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import LoadingComponent from "components/atoms/Loading";
import { FormStatus } from 'utils/constants/form-constants';
import GraphqlBuilder from "utils/request/graphql/builder";
import TabbedContent from 'components/molecules/TabbedContent'
import HelperString from 'utils/helper-string'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import QueryManagementEmailTemplate from 'graphql/queries/management/QueryManagementEmailTemplate'
import ObjectEmail from 'utils/objects/email'
import EmailData from 'scenes/management/emails/components/email/data'
import { createTranslationMutationParameters } from 'components/molecules/Form'
import MutationManagementEmailTemplate from 'graphql/mutations/management/MutationManagementEmailTemplate'

const ManagementEmailsEditScene = () => {
	
	const navigation = useNavigation();
	const isFocused = useIsFocused();
	const route = useRoute();
	
	const _languages = useSelector( state => {
		return state.data[dataConstants.LANGUAGES];
	} )
	
	const [ loading, setLoading ] = useState( true )
	const [ email, setEmail ] = useState( {} )
	
	const guid = _.get( route.params, 'guid', null );
	
	const fetchEmail = () => {
		if( guid !== null ) {
			new GraphqlBuilder()
				.addQuery( 'query', QueryManagementEmailTemplate, {
					guid: guid
				})
				.setResultPath( ['query', 'email_template'], {} )
				.setOnSuccess( result => {
					setLoading( false )
					setEmail( result )
				})
				.setOnError( setLoading.bind( this, false ) )
				.execute()
			
			return;
		}
		
		setLoading( false )
		setEmail( ObjectEmail.defaults )
	}
	
	const saveForm = ( values, { callback } = {} ) => {
		
		const parameters = createTranslationMutationParameters( values );
		
		values['translations'] = JSON.stringify( parameters )
		
		new GraphqlBuilder()
			.addQuery( 'mutation', MutationManagementEmailTemplate, values )
			.setResultPath( ['mutation', 'email_template'], {} )
			.setOnStart( () => {
				callback( FormStatus.LOADING )
			})
			.setOnSuccess( ( result ) => {
				callback( FormStatus.SUCCESS )
				
				fetchEmail()
			})
			.setOnError( ( result ) => {
				callback( FormStatus.ERROR )
			})
			.execute()
	}
	
	useEffect( () => {
		return fetchEmail();
	}, [ isFocused, guid ] )
	
	if( loading ) {
		return (
			<LoadingComponent />
		)
	}
	
	const tabBarItems = []
	
	// Data
	tabBarItems.push({
		key: 'data',
		text: i18n.t( 'management:form_block.title_default' ),
		scene: ( props ) => {
			return (
				<EmailData
					key={ HelperString.hash( 'email-data', email ) }
					{ ...props }
					email={ email }
					saveForm={ saveForm }
				/>
			);
		}
	});
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				title={ i18n.t('management:pages.emails.edit.title') }
				topNavigation={true}
				showBackButton={true}>
				
				<TabbedContent
					items={ tabBarItems }
				/>
			</ThemedLayout>
		</ThemedSafeAreaComponentTop>
	)
}

export default ManagementEmailsEditScene
